import { TemplateElement, html, defineElement, when, unsafeHTML, optionalAttribute } from '@webtides/element-js';
import style from './ad-bar.css';
import '../../../icon/icon.js';

/**
 * Advertising bar for one-to-many events. Renders above the hero (full bleed) or inside the main
 * area (contained, rounded). Below the @md breakpoint the link label is replaced by a chevron that
 * stretches over the whole bar.
 *
 * @property {string} icon
 * @property {string} text
 * @property {LinkProperties} link
 */
export default class AdBar extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            icon: '',
            text: '',
            link: undefined,
        };
    }

    template() {
        return html`
            <div
                class="ad-bar relative flex items-center justify-between gap-fix-2xs min-h-64 p-fix-s rounded-md bg-accent-1 text-primary-on-default @md:justify-center @md:gap-flex-2xs @md:p-flex-2xs"
                data-surface="dark"
            >
                ${when(this.icon, html`<mb-icon name="${this.icon}" size="24" class="shrink-0"></mb-icon>`)}
                <div class="ad-bar-text flex-1 min-w-0 fix-body3 @md:flex-none @md:fix-body2">
                    ${unsafeHTML(this.text)}
                </div>
                ${when(
                    this.link?.url,
                    html`
                        <a
                            class="ad-bar-link shrink-0 fix-body3 @md:fix-body2 ${this.link?.cssClasses || ''}"
                            href="${this.link?.url}"
                            aria-label="${this.link?.text}"
                            element="ad bar"
                            ${optionalAttribute(
                                this.link?.trackingLabel,
                                'tracking-label',
                                this.link?.trackingLabel,
                            )}
                        >
                            <span class="hidden @md:inline">${this.link?.text}</span>
                            <mdx-icon-chevron-right size="sm" class="@md:hidden"></mdx-icon-chevron-right>
                        </a>
                    `,
                )}
            </div>
        `;
    }
}

defineElement('mb-ad-bar', AdBar);
